<template>
    <DashboardLayout>
        <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
            <p class="mb-0 main-identifier fw-semibold">Delegation</p>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
            <p class="mb-0 sub-identifier">Delegate</p>
        </div>

        <div class="d-flex justify-content-center mb-5">

            <div class="form-outer">
                <form @submit.prevent="handleSubmit">
                    <div class="crud-form position-relative">

                        <div class="form-inner mb-2">
                            <div class="form-header d-flex justify-content-between align-items-center">
                                <h1 class="mb-0">Delegation</h1>
                            </div>

                            <div class="form-body">
                                <!-- Profile Header -->
                                <!-- <div class="row mb-3">
                                    <div class="profile-header mt-3">
                                        <div class="profile-photo-wrapper">
                                            <img :src="form.imageContent || blankAvatar" alt="User Photo"
                                                class="profile-photo">
                                            <div v-if="isLoading" class="photo-overlay">
                                                <span class="spinner-border spinner-border-sm"></span>
                                            </div>
                                        </div>
                                        <div class="profile-info">
                                            <h2 class="profile-name fw-bold mt-3 mb-0">{{ form.delegatee }}</h2>
                                            <p class="profile-email mb-0" style="color: #8d8d8d">
                                                {{ form.delegateeRoleName }}
                                            </p>
                                        </div>
                                    </div>
                                </div> -->
                                <div v-if="isDataLoaded">
                                    <div
                                        class="delegation-section d-flex justify-content-center align-items-stretch w-100">
                                        <!-- Delegator -->
                                        <div class="col mb-2">
                                            <div class="w-100">
                                                <label for="delegator" class="form-label fw-bold ms-2">Delegator</label>
                                                <input type="text" id="delegator" v-model="form.delegator"
                                                    class="form-control form-view-only-input" readonly>
                                            </div>
                                        </div>
                                        <!-- Delegator Role -->
                                        <div class="col  mb-2">
                                            <div class="w-100">
                                                <label for="delegatorRole" class="form-label fw-bold ms-2">Delegator
                                                    Role</label>
                                                <input type="text" id="delegatorRole" v-model="form.delegatorRoleName"
                                                    class="form-control form-view-only-input" readonly>
                                            </div>
                                        </div>
                                        <!-- Delegatee -->
                                        <div class="col mb-2">
                                            <div class="w-100">
                                                <label for="delegatee" class="form-label fw-bold ms-2">Delegatee</label>
                                                <input type="text" id="delegatee" v-model="form.delegatee"
                                                    class="form-control form-view-only-input" readonly>
                                            </div>
                                        </div>
                                        <!-- Delegatee Role -->
                                        <div class="col mb-2">
                                            <div class="w-100">
                                                <label for="delegateeRole" class="form-label fw-bold ms-2">Delegatee
                                                    Role</label>
                                                <input type="text" id="delegateeRole" v-model="form.delegateeRoleName"
                                                    class="form-control form-view-only-input" readonly>
                                            </div>
                                        </div>
                                        <!-- Date Section -->
                                        <div class="date-section col-md-6 w-100 mb-2">
                                            <!-- Start Date -->
                                            <div class="col">
                                                <div class="w-100">
                                                    <label for="startDate" class="form-label fw-bold ms-2">Start
                                                        Date</label>
                                                    <input type="date" id="startDate" v-model="form.startDate"
                                                        class="form-control" required>
                                                </div>
                                            </div>
                                            <!-- End Date -->
                                            <!-- <div class="col">
                                                <div class="w-100">
                                                    <label for="endDate" class="form-label ms-2">End Date</label>
                                                    <input type="date" id="endDate" v-model="form.endDate"
                                                        class="form-control" required>
                                                </div>
                                            </div> -->
                                        </div>

                                    </div>

                                    <div class="d-flex justify-content-end mt-2 mb-3">
                                        <button type="submit" class="btn btn-primary">Delegate</button>
                                    </div>
                                </div>
                                <div v-else class="loading-state text-center py-5 position-relative">
                                    <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                                    <p class="mt-2 mb-0 text-muted">Loading delegation...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import '@/assets/css/dashboard.css'
import axios from 'axios'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import DashboardLayout from '../layout/DashboardLayout.vue'
// import blankAvatar from '@/assets/images/blank-profile-avatar.png'

const isLoading = ref(false);
const isDataLoaded = ref(false);

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const form = ref({
    id: '',
    delegator: '',
    delegatee: '',
    delegatorId: '',
    delegatorRoleName: '',
    delegateeId: '',
    delegateeRoleName: '',
    startDate: '',
    endDate: '',
    statusInd: '',
    imageContent: '',
    errorMessage: ''
})

const getDelegatee = async () => {
    const token = Cookies.get('auth_token');
    isLoading.value = true;

    try {
        const { data } = await axios.get(`${root_api_url}/auth/delegation`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        form.value.id = data.id;
        form.value.delegator = data.delegator;
        form.value.delegatee = data.delegatee;
        form.value.delegatorId = data.delegatorId;
        form.value.delegatorRoleName = data.delegatorRoleName;
        form.value.delegateeId = data.delegateeId;
        form.value.delegateeRoleName = data.delegateeRoleName;
        form.value.imageContent = data.imageContent;
        form.value.startDate = data.startDate;
        form.value.endDate = data.endDate;
        form.value.statusInd = data.statusInd;
        form.value.errorMessage = data.errorMessage;
    } catch (error) {
        console.error('Error fetching delegatee:', error);
    } finally {
        isLoading.value = false;
        isDataLoaded.value = true;
    }
};

const handleSubmit = async () => {
    const token = Cookies.get('auth_token');
    isLoading.value = true;

    const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxFutureDate = new Date(today);
    maxFutureDate.setDate(today.getDate() + 30);
    // const todayString = today.toISOString().split('T')[0];
    // const maxFutureDateString = maxFutureDate.toISOString().split('T')[0];

    function toLocalDateString(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const todayString = toLocalDateString(today);
    const maxFutureDateString = toLocalDateString(maxFutureDate);

    if (form.value.startDate < todayString) {
        Swal.fire({
            html: `${iconHtmlError} <h1 style="font-weight:600;">Error</h1> <p>Cannot delegate from past dates</p> `,
            showConfirmButton: true,
            showCloseButton: true,
            icon: undefined,
        });
        await getDelegatee(); // Refresh the profile data
        return;
    }

    if (form.value.startDate > maxFutureDateString) {
        Swal.fire({
            html: `${iconHtmlError} <h1 style="font-weight:600;">Error</h1> <p>Cannot delegate from beyond 30 days in the future</p> `,
            showConfirmButton: true,
            showCloseButton: true,
            icon: undefined,
        });
        await getDelegatee(); // Refresh the profile data
        return;
    }

    try {
        const result = await axios.post(`${root_api_url}/auth/delegation/save`, form.value, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        console.log('Delegation data:', result.data);
        if (result.status === 200) {
            Swal.fire({
                html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Delegation Created Successfully</p> `,
                showConfirmButton: true,
                showCloseButton: true,
                icon: undefined,
            });
        }
        form.value.startDate = ''
    } catch (error) {
        console.error('Error fetching profile:', error);
        Swal.fire({
            html: `${iconHtmlError} <h1 style="font-weight:600;">Error</h1> <p>Failed to create delegation</p> `,
            showConfirmButton: true,
            showCloseButton: true,
            icon: undefined,
        });
    } finally {
        isLoading.value = false;
    }
};

onMounted(async () => {
    document.title = "Create Delegation"
    await getDelegatee();
});
</script>

<style scoped>
.profile-photo-wrapper {
    position: relative;
}

.photo-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    height: 120px;
    width: 120px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* PROFILE HEADER */
.profile-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
}

.profile-photo {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 3px solid #f1f1f1;
    margin-right: 1.5rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-info {
    text-align: left;
}

.delegation-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    /* border: 1px solid #e0e0e0; */
    border-radius: 0px;
}

.duration-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0px;
}

.duration-header {
    font-size: 1.25rem;
    color: #333;
    background: #eff3ff;
    padding: 0.5rem 1rem;
}

.date-section {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.date-section input {
    background: #f9f9f9;
    font-size: 0.9rem;
    color: #555;
    margin-bottom: 0.25rem;
}
</style>
